<template>
  <div />
</template>

<script>
export default {
  name: "BaseProfileBox",
  props: {
    result: {
      type: Object,
      default: null
    },

    updateStatus: {
      type: Boolean,
      default: false
    },

    deleteButton: {
      type: Boolean,
      default: false
    },

    index: {
      type: Number,
      default: -1
    }
  },

  computed: {
    to: function() {
      return "/profil?p=" + this.result.profile.pseudo;
    }
  },

  mounted: function() {
    this.result.component = this;
    if (this.updateStatus) this.$store.state.messager.joinChannel("/status/" + this.result.profile.pseudo);
  },

  methods: {
    receiveAlert: function(msg) {
      if (msg.data.type === "connection") {
        this.result.profile.connected = msg.data.message === "true";
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
